import { Colors, Flex, IconAdd, Typography } from '@banhala/ui-kit';

interface FolderCreateItemProps {
  width: number;
  onPress: () => void;
}

export const FolderCreateItem = ({ width, onPress }: FolderCreateItemProps) => {
  return (
    <Flex
      width={width}
      padding={{ bottom: 12 }}
      onPress={onPress}
      testID={`서랍추가`}
    >
      <Flex.Center
        width={width}
        height={width}
        backgroundColor={'bg_secondary'}
        borderRadius={'medium'}
      >
        <IconAdd size={24} fill={Colors.content_secondary} />
      </Flex.Center>
      <Flex padding={{ left: 4, top: 8 }}>
        <Typography type={'subtitle1.5'} color={'content_primary'}>
          서랍 추가하기
        </Typography>
        <Typography type={'body4'} color={'content_tertiary'}>
          나만의 취향을 모아보세요
        </Typography>
      </Flex>
    </Flex>
  );
};
